var _defs, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebSites(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 3001,
    height: 3001,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 0,
    cy: 0,
    r: 1500,
    fx: 0,
    fy: 0,
    gradientTransform: "translate(1500.5 1500.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.063,
    stopColor: "#FEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.102,
    stopColor: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.156,
    stopColor: "#FEFEFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.301,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.309,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FBFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691,
    stopColor: "#F9FAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.707,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.777,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.805,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.816,
    stopColor: "#F8F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.906,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7F7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M.5.5v3000h3000V.5Zm0 0"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    d: "M3000.5 3000.5H.5V.5h3000Zm0 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#100F0D",
    d: "M1500.5 1069.469c-261.441 0-474.14 212.691-474.14 474.133 0 261.437 212.699 474.136 474.14 474.136s474.14-212.699 474.14-474.136c0-261.442-212.699-474.133-474.14-474.133m0 1034.48c-308.988 0-560.344-251.379-560.344-560.347 0-308.961 251.356-560.34 560.344-560.34s560.34 251.379 560.34 560.34c0 308.968-251.352 560.347-560.34 560.347"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#100F0D",
    d: "M2017.738 1586.71H983.258v-86.21h1034.48zM1943.852 1309.61h-886.704v-86.212h886.704zM1925.371 1863.809H1075.63v-86.207h849.742z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#100F0D",
    d: "M1543.602 2060.84h-86.204V1026.36h86.204z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#100F0D",
    d: "M1500.5 1069.469c-126.852 0-234 217.11-234 474.133 0 257.027 107.148 474.136 234 474.136s234-217.11 234-474.136c0-257.024-107.148-474.133-234-474.133m0 1034.48c-179.55 0-320.2-246.12-320.2-560.347 0-314.223 140.65-560.34 320.2-560.34s320.2 246.117 320.2 560.34c0 314.226-140.65 560.347-320.2 560.347M336.707 789.27h2327.582V573.762c0-47.551-38.68-86.211-86.2-86.211H422.915c-47.523 0-86.207 38.66-86.207 86.21ZM2750.5 875.48h-2500V573.762c0-95.07 77.324-172.422 172.414-172.422H2578.09c95.082 0 172.41 77.351 172.41 172.422zM1972.48 2211.691l12.07 86.2H422.915c-95.262 0-172.414-77.153-172.414-172.41v-12.5c0-23.711 19.398-43.102 43.105-43.102 23.704 0 43.102 19.39 43.102 43.101v12.5c0 47.41 38.793 86.211 86.207 86.211z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#100F0D",
    d: "M2750.5 789.27v1336.21c0 60.348-31.898 114.649-80.602 145.258-2.59-29.738-15.949-56.898-37.93-78.02 19.821-15.948 32.321-40.519 32.321-67.238v-1250H336.707v1021.98c0 24.142-19.398 43.11-43.102 43.11-23.707 0-43.105-18.968-43.105-43.11V789.27z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#100F0D",
    d: "m2061.18 1910.7 84.058 603.491 103.801-190.37c15.281-27.571 44.961-43.801 76.02-43.88l217.293 3.637Zm83.808 688.96a87.7 87.7 0 0 1-16.25-1.52c-36.66-6.82-63.726-35.081-68.86-72.038l-84.398-605.782c-4.84-34.558 11.622-68.172 41.84-85.62 30.309-17.391 67.559-14.84 95.051 6.609l482.34 375.972c29.469 22.938 40.46 60.489 28.039 95.68-12.422 35.168-44.871 55.879-81.871 56.828l-217.29-3.64-104.73 189.562c-15.359 27.738-43.308 43.95-73.87 43.95M616.879 638.41c0 47.61-38.598 86.211-86.207 86.211-47.61 0-86.207-38.601-86.207-86.21 0-47.61 38.598-86.212 86.207-86.212 47.61 0 86.207 38.602 86.207 86.211M918.605 638.41c0 47.61-38.597 86.211-86.21 86.211-47.61 0-86.207-38.601-86.207-86.21 0-47.61 38.597-86.212 86.207-86.212 47.613 0 86.21 38.602 86.21 86.211M1220.328 638.41c0 47.61-38.598 86.211-86.207 86.211-47.61 0-86.21-38.601-86.21-86.21 0-47.61 38.6-86.212 86.21-86.212s86.207 38.602 86.207 86.211"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebSites);
export default __webpack_public_path__ + "static/media/webSites.f895d1e9f73bf2c000873641489afdc0.svg";
export { ForwardRef as ReactComponent };